// libs
import { connect } from 'react-redux';

// selectors
import { getRemoteConfig } from 'shared/store/remoteConfigs/selectors';

// selectors
import { getExploreProductID } from 'shared/store/details/selectors';

// actions
import { fetchExploreImages } from 'shared/store/details/services';

// helpers
import { getMapToState } from './helpers';

// components
import ExploreApi from './ExploreApi';

const mapStateToProps = (state: any) => ({
  // @ts-ignore
  ...getMapToState(getRemoteConfig(state, 'pdpExplore')),
  exploreProductID: getExploreProductID(state),
});

const mapDispatchToProps = {
  fetchExploreImages,
};

export default connect(mapStateToProps, mapDispatchToProps)(ExploreApi);
